export const USER_STATUS_ACTIVE = 'active'

export const USER_STATUS_BLOCKED = 'blocked'

export const USER_STATUS_EXISTED = 'existed'

export const USER_STATUS_IMPORTED = 'imported'

export const USER_STATUS_INVITED = 'invited'

export const USER_STATUS_NOT_CONFIRMED = 'not_confirmed'

export const USER_STATUS_UNEXISTED = 'unexisted'

export const USER_STATUS_LIST = [
  USER_STATUS_INVITED,
  USER_STATUS_ACTIVE,
  USER_STATUS_IMPORTED,
  USER_STATUS_BLOCKED,
  USER_STATUS_NOT_CONFIRMED,
]

export const USER_STATUS_CODE_INVITED = 0

export const USER_STATUS_CODE_ACTIVE = 1

export const USER_STATUS_CODE_IMPORTED = 2

export const USER_STATUS_CODE_BLOCKED = 3

export const USER_STATUS_CODE_NOT_CONFIRMED = 4

export const ADMIN_USER_ROLE = 'admin'

export const DWELLER_USER_ROLE = 'dweller'

export const LANDLORD_USER_ROLE = 'landlord'

export const MANAGER_USER_ROLE = 'manager'

export const WORKER_USER_ROLE = 'worker'

export const EXTERNAL_CONTACT_USER_ROLE = 'external_contact'

export const CONTRACTOR_USER_ROLE = 'contractor'

export const PROVIDER_USER_ROLE = 'provider' // not existing in DB, used for provider select

export const USER_PROFILE_OPTIONS_BASE_API_PARAMS = {
  archived: false,
}

export const USER_MANAGER_PROFILE_OPTIONS_API_PARAMS = {
  ...USER_PROFILE_OPTIONS_BASE_API_PARAMS,
  role: [ADMIN_USER_ROLE, MANAGER_USER_ROLE],
  with_field: ['avatar', 'company_post_name', 'role', 'status'],
}

export const USER_ADMIN_PROFILE_OPTIONS_API_PARAMS = {
  ...USER_MANAGER_PROFILE_OPTIONS_API_PARAMS,
  role: [ADMIN_USER_ROLE],
}

export const USER_INHABITANT_PROFILE_OPTIONS_API_PARAMS = {
  ...USER_PROFILE_OPTIONS_BASE_API_PARAMS,
  role: [DWELLER_USER_ROLE, LANDLORD_USER_ROLE],
  with_field: ['avatar', 'company_post_name', 'role', 'status'],
}

export const USER_REQUEST_APPLICANT_PROFILE_OPTIONS_API_PARAMS = {
  ...USER_INHABITANT_PROFILE_OPTIONS_API_PARAMS,
  with_self: true,
}

export const USER_SUPPLIER_PROFILE_OPTIONS_API_PARAMS = {
  ...USER_PROFILE_OPTIONS_BASE_API_PARAMS,
  role: [CONTRACTOR_USER_ROLE],
  with_field: ['avatar', 'email', 'role'],
}

export const USER_PROVIDER_PROFILE_OPTIONS_API_PARAMS = {
  ...USER_PROFILE_OPTIONS_BASE_API_PARAMS,
  role: [PROVIDER_USER_ROLE],
  with_field: ['avatar', 'email'],
}

export const USER_WORKER_PROFILE_OPTIONS_API_PARAMS = {
  ...USER_PROFILE_OPTIONS_BASE_API_PARAMS,
  role: [WORKER_USER_ROLE],
  with_field: ['avatar', 'role'],
}

export const USER_PROPERTY_OWNER_PROFILE_OPTIONS_API_PARAMS = {
  ...USER_PROFILE_OPTIONS_BASE_API_PARAMS,
  role: [LANDLORD_USER_ROLE],
  with_field: ['avatar', 'company_post_name', 'role', 'status'],
}

export const STAFF_USER_ROLES = [ADMIN_USER_ROLE, MANAGER_USER_ROLE]

export const DWELLER_USER_ROLES = [DWELLER_USER_ROLE, LANDLORD_USER_ROLE]

// Roles the NG user profile covers, mirroring the backend `PrimaryRolesPermission`.
export const PRIMARY_USER_ROLES = [...STAFF_USER_ROLES, ...DWELLER_USER_ROLES]

// The "About us — visibility of managers" company setting
// (`uk.config.team_visibility_mode`: 'all' | 'managers_only' | 'hide').
export const TEAM_VISIBILITY_MODE_HIDDEN = 'hide'

export const ROLE_TRANSLATION_ALIASES = {
  [ADMIN_USER_ROLE]: 'User.AdminRoleKey',
  [CONTRACTOR_USER_ROLE]: 'User.ProviderRoleKey',
  [DWELLER_USER_ROLE]: 'User.DwellerRoleKey',
  [EXTERNAL_CONTACT_USER_ROLE]: 'User.ExternalContactRoleKey',
  [LANDLORD_USER_ROLE]: 'User.LandlordRoleKey',
  [MANAGER_USER_ROLE]: 'User.ManagerRoleKey',
  [PROVIDER_USER_ROLE]: 'User.ProviderRoleKey',
  [WORKER_USER_ROLE]: 'User.WorkerRoleKey',
}

export const USER_STATUS_TEXT = [
  { color: 'var(--color-in-progress)', text: 'User.StatusInvitedKey' },
  { color: 'var(--color-success)', text: 'User.StatusOnlineKey' },
  { color: 'var(--color-info)', text: 'User.StatusImportedKey' },
  { color: 'var(--color-error)', text: 'User.StatusBlockedKey' },
  { color: 'var(--color-declined)', text: 'User.StatusInvalidKey' },
]

export const USER_ITEM_SUPPORT_EMAIL = 'support@idwell.com'

export const USER_ITEM_SUPPORT = {
  avatar_color: '#C9DC98',
  email: USER_ITEM_SUPPORT_EMAIL,
  fullname: 'Support',
  id: USER_ITEM_SUPPORT_EMAIL,
}

/**
 * @type {{drafts: Map<string, any>}}
 */
export const DEFAULT_USER_STORAGE = {
  drafts: new Map(),
}

export const USER_MAIL_SUPPORT_LINK = 'mailto:contact@idwell.com'

export const USER_SELECT_OLD_API_DEFAULT_AVATAR_SEARCH_STRING =
  '/sys/default_avatar.png'
